import { Deserializable } from '../../protocols/deserializable';
import { RelationshipStatusType } from '../../types/dto/relationship-status-type';
import { RelationshipStatus } from '../../enum/shared/relationship-status';
import { Spouse } from './spouse';
import { DateUtils } from '../../../utils/date-utils';

export class MemberRelationshipStatus implements Deserializable {
  public id!: number;
  public memberId!: number;
  public typeId!: RelationshipStatus;
  public type!: RelationshipStatusType;
  public spouseId?: number;
  public spouse!: Spouse;
  public effectiveDate!: string;
  public endDate?: string;

  // Not from API
  public formattedDate!: string;

  public onDeserialize() {
    if (!!this.type) {
      this.type = window?.injector?.Deserialize?.instanceOf(RelationshipStatusType, this.type);
    }
    if (!!this.spouse) {
      this.spouse = window?.injector?.Deserialize?.instanceOf(Spouse, this.spouse);
    }
    if (!!this.effectiveDate) {
      this.formattedDate = DateUtils.formatDateStringToCurrentDate(this.effectiveDate);
    }
  }
}
